import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import settingsData from '../assets/settings.json';

@Injectable({
  providedIn: 'root'
})
export class RegoService {

  constructor(private http: HttpClient) { }

  register(data) {
    const registrationObj = data;

    if (window.location.hostname === 'localhost') {
      registrationObj._env = 'localhost';
    }

    return new Promise((resolve, reject) => {
      this.http.post('https://my.interact.technology/utilities/new/api.php?customRegister', registrationObj, {
      }).subscribe((response: any) => {
        resolve(response);
      });
    });


  }

}
